// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__IX9ze","item":"PaymentsMobile_item__2h7XK","label":"PaymentsMobile_label__27eE6","amount":"PaymentsMobile_amount__1UMQg"};